// src/components/Navbar.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import NodeSphereIcon from "./icons/NodeSphereIcon";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => setIsOpen(!isOpen);

  const closeDrawer = () => setIsOpen(false); // Explicit close function for clarity

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="logo">
            <span className="logo-text">Mosaic</span>
            <NodeSphereIcon />
            <span className="logo-tech">Tech</span>
          </Link>

          <div className="menu-icon" onClick={toggleDrawer}>
            <FiMenu size={28} />
          </div>

          <div className="nav-links desktop">
            <Link to="/portfolio">Portfolio</Link>
            <Link to="/mint">Mint</Link>
            <Link to="/team">Team</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/web3">Web3</Link>
            <Link to="/agency">MOTA</Link>
            <Link to="/signin" className="signin-btn">
              Sign In
            </Link>
          </div>
        </div>

        {/* Mobile Menu Drawer */}
        {isOpen && (
          <div className="mobile-drawer">
            <div className="mobile-drawer-header">
              <div className="close-icon" onClick={closeDrawer}>
                <FiX size={28} />
              </div>
            </div>
            <Link to="/portfolio" onClick={closeDrawer}>
              Portfolio
            </Link>
          
            <Link to="/contact" onClick={closeDrawer}>
              Contact
            </Link>
            <Link to="/web3" onClick={closeDrawer}>
              Web3
            </Link>
            <Link to="/mint" onClick={closeDrawer}>
              Mint
            </Link>
            <Link to="/Agency" onClick={closeDrawer}>
              MOTA
            </Link>
            
            <Link to="/signin" onClick={closeDrawer}>
              Sign In
            </Link>
              <Link to="/team" onClick={closeDrawer}>
              {/* Team */}
            </Link>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
